import { formatDateShortDD } from '~/services/TimeService';

import { type ChecklistStatus, isFiniteNumber } from './checklistUtils';

export function getStatusLabel(status: ChecklistStatus) {
  switch (status) {
    case 'approved':
      return 'Approved';
    case 'requires approval':
      return 'Requires approval';
    case 'blocked':
      return 'Blocked';
    default:
      return 'Unknown';
  }
}

export function formatOptionalNumber(value?: number) {
  return isFiniteNumber(value) ? String(value) : 'N/A';
}

export function formatMoney(value?: number | null, currencyCode = 'AUD') {
  return isFiniteNumber(value) ? `${currencyCode} ${value}` : 'N/A';
}

export function formatPrice(value: string | number | null | undefined, currencyCode = 'AUD') {
  if (value == null || value === '') {
    return '—';
  }
  return `${currencyCode} ${value}`;
}

export function formatContextDate(value?: string) {
  return value ? formatDateShortDD(value) : 'Not available';
}

export function formatBooleanDataPointValue({
  dataAvailable,
  enabled,
  unavailableValue = 'N/A',
}: {
  dataAvailable: boolean;
  enabled?: boolean;
  unavailableValue?: string;
}) {
  if (!dataAvailable) {
    return unavailableValue;
  }
  return enabled ? 'Yes' : 'No';
}

export function formatLoadedDataPointValue({ dataAvailable, loaded }: { dataAvailable: boolean; loaded: boolean }) {
  if (!dataAvailable) {
    return 'N/A';
  }
  return loaded ? 'Loaded' : 'Not loaded';
}

// Deal option names come through as e.g. "5n Duplex w/ Pool 6A" — capitalize the nights
// abbreviation for display ("5N Duplex...").
export function formatDealOptionName(name: string) {
  return name.replace(/^(\d+)n\b/i, '$1N');
}

export function getDealToggleLabel({ dealCount, dealsExpanded }: { dealCount: number; dealsExpanded: boolean }) {
  const dealNoun = dealCount === 1 ? 'deal option' : 'deal options';
  return `${dealsExpanded ? 'Hide' : 'View'} ${dealCount} ${dealNoun}`;
}
